import { HEADER_TABS } from '../../constants/tabGroups';
import { useAppSelector } from '../../helpers/store';
import getTabOptions from '../../util/getTabOptions';
import { ISSUPERADMIN, USERROUTES, checkUserPermission } from '../../util/userPermission';

export function useHeaderTabs() {
  const userAccess = useAppSelector((state) => state.userAccess);
  const userRoutes = checkUserPermission(userAccess, USERROUTES) as unknown[];

  const isSuperAdmin = checkUserPermission(userAccess, ISSUPERADMIN);

  // Yog Admin no longer appears here — it moved to the Admin tab row and is
  // marked hideInNav, so getTabOptions already filters it out.
  return getTabOptions(isSuperAdmin, HEADER_TABS, userRoutes);
}
